import React from 'react';
import { connect } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

const UserRoute = (props) => {
  const user = props.user || JSON.parse(localStorage.getItem('user'));
  console.log('user')
  console.log(user)
  if (!user) {
    return <Navigate to="/login" />;
  }
  
  return <Outlet />;
};

const mapStateToProps = (state) => {
  return {
    user: state.userReducer.user,
  };
};

export default connect(mapStateToProps)(UserRoute);